import http from '~/common/http'

export default {
    //地区试卷列表
	getList(params) {
        return http.get('/api/product/jb3/eliet-school-list', {
            params: params
        });
    },

    create(params){
        return http.post('/api/product/jb3/create-hide-school', params);
    },

    delete(params){
        return http.post('/api/product/jb3/delete-hide-school', params);
    },

    //地区列表
	getCheckedId(params) {
        return http.get('/api/product/jb3/select-district-id', {
            params: params
        });
    },

    //地区勾选
	districtCheck(params) {
        return http.post('/api/product/jb3/district-check', params);
    },

    //隐藏学校列表
	getHideList(params) {
        return http.get('/api/product/jb3/hide-school-list', {
            params: params
        });
    },


    //以下是在线组卷接口
    getZujuanElietSchoolList(params) {
        return http.get('/api/product/zujuan/eliet-school-list', {
            params: params
        });
    },

    createZujuanHideSchool(params){
        return http.post('/api/product/zujuan/create-hide-school', params);
    },

    deleteZujuanHideSchool(params){
        return http.post('/api/product/zujuan/delete-hide-school', params);
},

    //地区列表
    selectZujuanDistrictId(params) {
        return http.get('/api/product/zujuan/select-district-id', {
            params: params
        });
    },

    //地区勾选
    zujuanDistrictCheck(params) {
        return http.post('/api/product/zujuan/district-check', params);
    },

    //隐藏学校列表
    getZujuanHideList(params) {
        return http.get('/api/product/zujuan/hide-school-list', {
            params: params
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/elietschool.js